<template>
    <div id="app2">
      <v-app>
          <router-view></router-view>
      </v-app>
    </div>
</template>

<script>
export default {
  name: "app",
  created() {
    const me = this;
    me.$lang.setLang("en-US");
  },
};
</script>

<style>
#app2 {
  min-height: 100vh;
  position: relative;
}
.v-application .headline, .v-application .title, .v-application .title span{
  font-family:system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif!important;
}
/* Let page-level wrappers (e.g. login) own the background. */
.v-application {
  font-family:system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif!important;
  background: transparent !important;
}
</style>
